import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ContentfulImage from '../../components/ContentfulImage';
import media from '../../styles/media.style';

const HeaderContainer = styled.section`
  max-width: 1440px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  ${media.tabletL`
    margin-left: auto;
    margin-right: auto;
  `};
`;
const HeaderImgCover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: 40px;
  ${media.tabletP`
    margin-bottom: 0;
  `};
`;
const HeaderTitleCover = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: 0;
  width: 100%;
  @media (min-width: 1295px) {
    width: auto;
  }
`;
const HeaderTitleText1 = styled.div`
  // font-family: FuturaPT-Medium;
  font-size: 18px;
  color: #000;
  ${media.tabletP`
      margin-top: 40px;
  `};
  ${media.tabletL`
      margin-top: 40px;
  `};
`;
const HeaderTitleText2 = styled.div`
  // font-family: HiraKakuStd-W3;
  font-size: 30px;
  letter-spacing: 3px;
  margin-top: 10px;
  color: #000;
  ${media.tabletL`
      margin-top: 30px;
  `};
`;
const HeaderTitleButton = styled.div`
  width: 320px;
  height: 64px;
  margin-top: 40px;
  margin-bottom: 40px;
  color: #fff;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${media.tabletP`
      margin-top: 40px;
      margin-bottom: 40px;
  `};
  ${media.tabletL`
      margin-top: 40px;
      margin-bottom: 40px;
  `};
`;
const image = {
  title: 'TGM KIT',
  file: {
    url:
      // '//images.ctfassets.net/qf666eyypqhw/SpD29AyfQswiA6uUEUeaW/26a8d6554c72360f9cbfa0b2cb5dd353/THC_AD_KeyVisual.jpg?h=1126&w=2400',
      '//images.ctfassets.net/qf666eyypqhw/3JEjQ9AQxTkZeS3JNEyLO4/dd33a915beda8c55826a4b4c9a65a28a/salonsearch_top_img.jpg?h=1126&w=2400',
    details: {
      size: 62318,
      image: {
        width: 961,
        height: 450,
      },
    },
    // fileName: 'THC_AF_Treatment_250g.jpg',
    fileName: 'salonsearch_top_img.jpg',
    contentType: 'image/jpeg',
  },
  assetId: 'dd33a915beda8c55826a4b4c9a65a28a',
};

class LineHeader extends Component {
  componentWillMount = () => {
    // const props = this.props;
  };

  render() {
    // const props = this.props;
    // const { copy, siteOption, locale, prefectures } = this.props;
    const { locale } = this.props;
    return (
      <HeaderContainer>
        <HeaderImgCover>
          <ContentfulImage src={image} marginSet="0" objectPosition="relative" />
        </HeaderImgCover>
        <HeaderTitleCover>
          <HeaderTitleText1>THE GROOMING KIT</HeaderTitleText1>
          <HeaderTitleText2>取り扱いサロン一覧</HeaderTitleText2>
          <HeaderTitleButton>
            <Link
              to={`/${locale}/news-and-events/campaign-20190401-kolor`}
              href={`/${locale}/news-and-events/campaign-20190401-kolor`}
            >
              商品情報はこちら
            </Link>
          </HeaderTitleButton>
        </HeaderTitleCover>
      </HeaderContainer>
    );
  }
}

LineHeader.propTypes = {
  locale: PropTypes.string.isRequired,
};

const mapState = state => ({
  siteOption: state.siteOptions,
  copy: state.siteOptions.siteCopySalonLocator,
  prefectures: state.siteOptions.prefectures,
  locale: state.locale,
  lines: state.siteOptions.menu,
});

export default connect(mapState)(LineHeader);



// WEBPACK FOOTER //
// ./src/pages/SalonListGrooming/LineHeader.js